<script setup lang="ts">

import { useOnboardingPresentation } from './OnboardingPresentation';
import Presentation from '@presentation/Templates/Presentation.vue';

useOnboardingPresentation(); 

</script>

<template>
    <Presentation />
</template>